import { APICore } from "./apiCore";

const api = new APICore();

// Get all locations
function getPackagesApi() {
  const baseUrl = "/web/packages";
  return api.get(`${baseUrl}`, {});
}

// Update a location
function updatePackageApi(
  params: {
    id: string;
    name: string;
    description: string;
    price: number;
    duration: number;
    type: string;
    status: string;
  },
  image: File[] | null | string
) {
  const baseUrl = "/web/packages";

  return api.updateWithFiles(`${baseUrl}/${params.id}`, image, params);
}

// Add a new location
function addPackageApi(params: { name: string; description: string; price: number; duration: number; image: File[] | null | string; type: string }) {
  const baseUrl = "/web/packages";
  return api.createWithFile(`${baseUrl}`, params);
}

function deletePackageApi(params: { id: string }) {
  const baseUrl = "/web/packages";
  return api.delete(`${baseUrl}/${params.id}`);
}

export { getPackagesApi, updatePackageApi, addPackageApi, deletePackageApi };
